import CloseIcon from './CloseIcon.jsx';
// Reusable bottom sheet for mobile, slides up from bottom edge
// Usage: <BottomSheet open={open} onClose={() => setOpen(false)} title="Layers">...</BottomSheet>

import { useRef } from 'react';
import { createPortal } from 'react-dom';
import { useModalFocus } from '../hooks/useModalFocus.js';

export default function BottomSheet({ open, onClose, title, children, maxHeight = '75vh' }) {
  const dialog = useRef(null);
  useModalFocus(dialog, onClose, open);
  if (!open) return null;

  return createPortal(
    <div style={{
      position: 'fixed', inset: 0, zIndex: 200,
      display: 'flex', flexDirection: 'column', justifyContent: 'flex-end',
    }}>
      {/* Backdrop */}
      <div
        style={{ position: 'absolute', inset: 0, background: 'rgba(0,0,0,0.6)' }}
        onClick={onClose}
      />

      {/* Sheet */}
      <div ref={dialog} role="dialog" aria-modal="true" aria-label={title || 'Details'} tabIndex={-1} style={{
        position: 'relative', zIndex: 1,
        background: 'var(--bg-2)',
        borderTop: '1px solid var(--hair-2)',
        borderRadius: '16px 16px 0 0',
        maxHeight: `min(${maxHeight}, calc(100dvh - 16px))`, paddingBottom:'env(safe-area-inset-bottom)',
        display: 'flex', flexDirection: 'column',
        backdropFilter: 'blur(12px)',
      }}>
        {/* Handle + header */}
        <div style={{
          display: 'flex', alignItems: 'center', justifyContent: 'space-between',
          padding: '12px 16px 8px',
          borderBottom: title ? '1px solid var(--hair)' : 'none',
          flexShrink: 0,
        }}>
          <div style={{
            position: 'absolute', left: '50%', top: 8,
            transform: 'translateX(-50%)',
            width: 36, height: 4, background: 'var(--txt-dim)', borderRadius: 2,
          }} />
          {title && (
            <span style={{ fontSize: 'var(--ui-body)', fontWeight: 700, fontFamily: 'var(--mono)',
                           color: 'var(--txt-dim)', letterSpacing: 0.5, marginTop: 4 }}>
              {title}
            </span>
          )}
          <button title="Close" className="og-close-control"
            onClick={onClose} aria-label="Close"
            style={{ background: 'none', border: 'none', color: 'var(--txt-dim)',
                     cursor: 'pointer', fontSize: 18, padding: '4px 8px',
                     marginLeft: 'auto', minWidth:44, minHeight:44, lineHeight: 1 }}
          ><CloseIcon /></button>
        </div>

        {/* Content, scrollable */}
        <div style={{ overflowY: 'auto', flex: 1, padding: '8px 0 16px' }}>
          {children}
        </div>
      </div>
    </div>, document.body
  );
}
